import _ from 'lodash';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { GlobalConst } from '../appConfig/globalConst';


export function getUserDetails(userObject) {
    if (!_.isEmpty(userObject)) {
        if (!_.isEmpty(userObject.userDetails) && !_.isEmpty(userObject.userDetails.name)) {
            return userObject.userDetails.name;
        }
        if (!_.isEmpty(userObject.userDetails) && !_.isEmpty(userObject.userDetails.preferred_username)) {
            return userObject.userDetails.preferred_username;
        }
        if (!_.isEmpty(userObject.email) && !_.isEmpty(userObject.userDetails.email)) {
            return userObject.userDetails.email;
        }
    }
    return 'user';
}

export function getName(userData) {
    if (_.isEmpty(userData)) {
        return 'Anonymous'
    }
    let returnText = (userData.userDetails.name) ? userData.userDetails.name : userData.userDetails.preferred_username;
    return returnText;
}

export function getUserDisplayChar(user) {
    // Check if the input is empty (null or undefined)
    if (_.isEmpty(user)) {
        return '';
    }
    let text = (user.preferred_username) ? user.preferred_username : user.email;
    // Extract the first character of the text and capitalize it
    const firstInitial = _.upperCase(_.head(text));
    return firstInitial;
}

export function getAvatar(userObject, size, addClass) {
    if (!_.isEmpty(userObject.userDetails)) {
        return <Avatar style={{ backgroundColor: '#266FF2', color: '#ffffff' }} className={addClass} size={size ? size : 'default'}><span className='text-white'>{getUserDisplayChar(userObject.userDetails)}</span></Avatar>;
    }
    else {
        // console.log("I am in the else block");
        return <Avatar icon={<UserOutlined />} />;
    }
}

export function getTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};


export function deleteCookie() {
    document.cookie = `session_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${GlobalConst.COOKIE_DOMAIN}`;
    document.cookie = `refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${GlobalConst.COOKIE_DOMAIN}`;
}

export function checkEvenOdd(num) {
    return num % 2 === 0 ? "even" : "odd";
}


export function getUserImagePath(imgURL) {
    let userImagePath = '';
    if (!_.isEmpty(imgURL) && !_.isEmpty(imgURL.path)) {
        let splitPath = imgURL.path.split('public');
        return `${GlobalConst.API_URL}${splitPath[1]}`;
    }
    return userImagePath;
}
